module.exports = __webpack_public_path__ + "static/img/div3_4.e832b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/specailPage/div3_4.png
// module id = kk52
// module chunks = 1